import React from "react";

type Props = {
    label?: string;
};

export default function MediaUpload(props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & Props) {
    const { label, id } = props;
    const image = React.useRef<HTMLImageElement>(null);

    const loadFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        const input = event.target;
        const file = input.files[0];
        image.current.src = URL.createObjectURL(file);
    };

    return (
        <>
            <label htmlFor={id}>
                {label}
            </label>
            <input
                id={id}
                type="file"
                onChange={e => {
                    loadFile(e);
                    props.onChange(e);
                }}
            />
        </>
    );
}